import belter from 'belter';
// @ts-ignore
import zoid from '@krakenjs/zoid/dist/zoid.frameworks';
import {CLASS} from '../enums';

export enum EVENT {
  BEFORE_CLOSE = 'BEFORE_CLOSE'
}

export function containerTemplate({
  uid,
  frame,
  prerenderFrame,
  doc,
  props,
  event,
  dimensions: {width, height}
}: Record<any, any>): HTMLElement | undefined {
  if (!frame || !prerenderFrame) {
    return;
  }

  const div = doc.createElement('div');
  const backdrop = doc.createElement('div');
  div.setAttribute('id', uid);
  backdrop.classList.add('backdrop');
  div.appendChild(backdrop);
  const style = doc.createElement('style');
  if (props.cspNonce) {
    style.setAttribute('nonce', props.cspNonce);
  }

  style.appendChild(
    doc.createTextNode(`
      #${uid} {
          position: fixed;
          overflow: hidden;
          display: block;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          width: ${width};
          height: ${height};
          z-index: 99999;
      }
      #${uid} > .backdrop {
          position: fixed;
          display: block;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(40, 40, 40, 0.7);
          transition: opacity 0.35s ease-in-out;
          opacity: 0;
          will-change: opacity;
      }
      #${uid} > .backdrop.${CLASS.VISIBLE} {
          opacity: 1;
      }
      #${uid} > iframe {
          display: inline-block;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          transition: all .2s ease-in-out;
      }
      #${uid} > iframe.${CLASS.INVISIBLE} {
          opacity: 0;
      }
      #${uid} > iframe.${CLASS.VISIBLE} {
          opacity: 1;
      }
    `)
  );

  div.appendChild(frame);
  div.appendChild(prerenderFrame);
  div.appendChild(style);

  prerenderFrame.classList.add(CLASS.VISIBLE);
  frame.classList.add(CLASS.INVISIBLE);

  setTimeout(() => {
    backdrop.classList.add(CLASS.VISIBLE);
  }, 1);

  event.on(zoid.EVENT.RENDERED, () => {
    prerenderFrame.classList.remove(CLASS.VISIBLE);
    prerenderFrame.classList.add(CLASS.INVISIBLE);

    frame.classList.remove(CLASS.INVISIBLE);
    frame.classList.add(CLASS.VISIBLE);

    setTimeout(() => {
      belter.destroyElement(prerenderFrame);
    }, 1);
  });

  event.on(EVENT.BEFORE_CLOSE, () => {
    backdrop.classList.remove(CLASS.VISIBLE);
  });

  event.on(zoid.EVENT.RESIZE, ({width: newWidth, height: newHeight}: Record<any, any>) => {
    if (typeof newWidth === 'number') {
      div.style.width = belter.toCSS(newWidth);
    }

    if (typeof newHeight === 'number') {
      div.style.height = belter.toCSS(newHeight);
    }
  });

  return div;
}
